import { render, staticRenderFns } from "./side-menu-link.vue?vue&type=template&id=35742f81&scoped=true&"
import script from "./side-menu-link.vue?vue&type=script&lang=js&"
export * from "./side-menu-link.vue?vue&type=script&lang=js&"
import style0 from "./styles/side-menu-link.scss?vue&type=style&index=0&id=35742f81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35742f81",
  null
  
)

component.options.__file = "side-menu-link.vue"
export default component.exports